import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const app422ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    pastApp: yup
      .object()
      .shape({ m02_id: yup.string(), label: yup.string() })
      .nullable()
      .default(undefined)
      .transform((value, originalValue) => {
        if (
          originalValue &&
          typeof originalValue === "object" &&
          Object.keys(originalValue).length === 0
        ) {
          return undefined;
        }
        return value;
      }),
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocIsologismos: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
